module.exports = __webpack_public_path__ + "img/step-library-zh.bdb9405d.webp";